import React, { useState, useEffect } from "react";
import { View } from "react-native-web";
import styles from "./styles";

const ShrinkingBar = ({ shrinkTime, gameStarted, gameEnded, updateScore, incorrectGuess, resetIncorrectGuess }) => {
  const [width, setWidth] = useState(100);
  const [isShrinkingStarted, setIsShrinkingStarted] = useState(false);
  const [showPenalty, setShowPenalty] = useState(false); // State to control flashing of the number "2"
  const [delayStarted, setDelayStarted] = useState(false); // State to track if the delay has started

  // Start shrinking when the game starts and reset when it ends
  useEffect(() => {
    if (gameStarted && !gameEnded && !delayStarted) {
      setDelayStarted(true);
      // Start the shrinking process after 2 seconds delay
      setTimeout(() => {
        setIsShrinkingStarted(true);
        setWidth(100); // Reset width when game starts
        setShowPenalty(false); // Reset flashing number
      }, 2000); // 2 seconds delay
    } else if (!gameStarted || gameEnded) {
      setIsShrinkingStarted(false);
      setDelayStarted(false); // Reset delay state when game ends
    }
  }, [gameStarted, gameEnded, delayStarted]);

  useEffect(() => {
    if (gameEnded || !isShrinkingStarted) return;

    const interval = setInterval(() => {
      setWidth((prevWidth) => {
        const decrement = 100 / shrinkTime;
        let newWidth = prevWidth - decrement;

        // Apply penalty for incorrect guess
        if (incorrectGuess) {
          newWidth -= 1.5; // Apply penalty
          setShowPenalty(true); // Trigger the flashing number
          resetIncorrectGuess(); // Notify parent to reset
          console.log("Incorrect guess penalty applied");

          // Hide the penalty number after 1 second
          setTimeout(() => {
            setShowPenalty(false);
          }, 1000); // The flashing number disappears after 1 second
        }

        if (newWidth <= 0) {
          clearInterval(interval);
          setWidth(0);
          updateScore(0);
          return 0;
        }

        updateScore(newWidth);
        return newWidth;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isShrinkingStarted, shrinkTime, gameEnded, updateScore, incorrectGuess, resetIncorrectGuess]);

  return (
    <View style={styles.timerCountdown}>
      <div style={{ width: "80%", height: "30px", backgroundColor: "#e0e0e0", position: "relative" }}>
        <div
          style={{
            height: "100%",
            width: `${width}%`,
            backgroundColor: "#27ae60",
            transition: "width 0.1s linear", // Smooth transition for bar width
          }}
        />
        {/* Flashing "2" when incorrect guess is made */}
        {showPenalty && (
          <div
            style={{
              position: "absolute",
              right: "-30px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "20px",
              fontWeight: "bold",
              color: "red",
              animation: "flash 1s infinite", // Use the 'flash' animation from the CSS file
            }}
          >
            -2
          </div>
        )}
      </div>
      <div style={{ marginTop: "10px", fontSize: "18px", fontWeight: "bold" }}>
        Score: {Math.round(width)}/100
      </div>
    </View>
  );
};

export default ShrinkingBar;
